import { NotificationCenter } from "@expert/solve-tools";
import { Flex, Group } from "@mantine/core";
import { useExpertAssistStore } from "../../state";
import { isProd } from "../../utils";
import { type FeedbackNotificationType, useFeedbackNotification } from "../feedback";
import { AsurionAssistLogo } from "../svgs";
import { EnvironmentBadge, LobBadge, PartnerBadge } from "./badges";
import { Menu } from "./Menu";
import classes from "./styles.module.css";

export function Header() {
    const {
        expertProfile: { firstName, lastName },
        token,
        lob,
        partner,
    } = useExpertAssistStore();
    const isAuthenticated = token && (firstName || lastName);
    const triggerNotification = useFeedbackNotification();

    return (
        <Flex direction="row" justify="space-between" data-testid="header" className={classes.header}>
            <Group align="center" gap="sm">
                <AsurionAssistLogo />
                {!isProd && <EnvironmentBadge />}
                {!isProd && <PartnerBadge partner={partner} />}
                {!isProd && isAuthenticated && <LobBadge lob={lob} />}
            </Group>
            <Group align="center" gap="md" className={classes.rightControls}>
                {isAuthenticated && (
                    <>
                        <div className={classes.alignedNotification}>
                            <NotificationCenter />
                        </div>
                        <Menu
                            onClose={(type: FeedbackNotificationType) => {
                                triggerNotification(type);
                            }}
                        />
                    </>
                )}
            </Group>
        </Flex>
    );
}
